export const prepareBudgetValues = (values = {}) => {
  const budget = {
    ...values,
    unlimitedClaims: Boolean(values.unlimitedClaims),
  };

  if (budget.unlimitedClaims) {
    delete budget.maxClick;
    delete budget.clickPeriod;
  }

  return budget;
};
